import { ChevronDown, ChevronRight } from 'lucide-react';

/** Chevron in a timeline lane's left label column that minimizes / expands the lane. */
export function TimelineLaneMinimizeButton({ collapsed, onToggle, label = 'track', testId }) {
  const action = collapsed ? `Expand ${label}` : `Minimize ${label}`;
  const Icon = collapsed ? ChevronRight : ChevronDown;
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onToggle?.();
      }}
      className="shrink-0 rounded p-0.5 opacity-60 hover:opacity-100 hover:bg-white/10 transition"
      style={{ color: 'var(--text-secondary)' }}
      title={action}
      aria-label={action}
      aria-expanded={!collapsed}
      data-testid={testId}
    >
      <Icon className="w-3 h-3" />
    </button>
  );
}

export default TimelineLaneMinimizeButton;
